import { start } from '@jutro/app';
import { initDefaultGA, initDefaultMixpanel } from '@jutro/events';
import { LocaleService } from 'gw-portals-i18n-react';
import { ServiceManager } from '@jutro/services';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { adacThemeConfig } from './config/theme/adacThemeConfig';
import 'regenerator-runtime';

import App from './app/App';

const { trackingConfig = {} } = appConfig;

const gaTrackingId = trackingConfig.GA_TRACKING_ID;
const mixpanelTrackingId = trackingConfig.MIXPANEL_TRACKING_ID;

if (window.self === window.top) {
    const theBody = document.getElementsByTagName('body')[0];
    theBody.style.display = 'block';
} else {
    window.top.location = window.self.location;
}

if (gaTrackingId) {
    initDefaultGA(trackingConfig);
}
if (mixpanelTrackingId) {
    initDefaultMixpanel(trackingConfig);
}

start(App, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    refreshOnLanguageOrLocaleChange: true,
    routerBasename: '/ambulance-app',
    onInit: () => {
        LocaleService.register();
        ServiceManager.getService('locale-service').saveLanguage('de');
    },
    appName: {
        id: 'digital.appName',
        defaultMessage: 'ADAC'
    },
    themeConfig: adacThemeConfig,
    appDescription: 'CustomerEngage Account Management for ClaimCenter'
});
